var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.49219 13.2621V5.26215C3.49219 4.71215 3.68819 4.24115 4.08019 3.84915C4.47219 3.45715 4.94286 3.26148 5.49219 3.26215H11.4922V13.2621H3.49219ZM13.4922 3.26215H19.4922C20.0422 3.26215 20.5132 3.45815 20.9052 3.85015C21.2972 4.24215 21.4929 4.71281 21.4922 5.26215V9.26215H13.4922V3.26215ZM13.4922 21.2621V11.2621H21.4922V19.2621C21.4922 19.8121 21.2962 20.2831 20.9042 20.6751C20.5122 21.0671 20.0415 21.2628 19.4922 21.2621H13.4922ZM3.49219 15.2621H11.4922V21.2621H5.49219C4.94219 21.2621 4.47119 21.0661 4.07919 20.6741C3.68719 20.2821 3.49152 19.8115 3.49219 19.2621V15.2621ZM5.49219 11.2621H9.49219V5.26215H5.49219V11.2621ZM15.4922 7.26215H19.4922V5.26215H15.4922V7.26215ZM15.4922 13.2621V19.2621H19.4922V13.2621H15.4922ZM5.49219 17.2621V19.2621H9.49219V17.2621H5.49219Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard-icon.2e5f15290ca218a6c1996e1a89d388ff.svg";
export { ForwardRef as ReactComponent };